import React, {
  useEffect
} from "react";

import {
  FiCheckCircle,
  FiGift,
  FiX
} from "react-icons/fi";

const ClaimModal = ({

  achievement,

  onClose

}) => {

  useEffect(() => {

    const handleKey = (e) => {

      if (

        e.key === "Escape"

      ) {

        onClose();

      }

    };

    window.addEventListener(

      "keydown",

      handleKey

    );

    return () =>

      window.removeEventListener(

        "keydown",

        handleKey

      );

  }, [onClose]);

  if (!achievement)

    return null;

  return (

    <div

      className="claim-modal-overlay"

      onClick={onClose}

    >

      <div

        className="claim-modal"

        onClick={(e) =>

          e.stopPropagation()

        }

      >

        {/* CLOSE */}

        <button

          className="claim-close"

          onClick={onClose}

        >

          <FiX />

        </button>

        {/* HEADER */}

        <div className="claim-header">

          <div className="claim-badge">

            {

              achievement.icon?.includes(".png") ||

              achievement.icon?.includes(".svg")

              ?

              (

                <img

                  src={achievement.icon}

                  alt={achievement.title}

                />

              )

              :

              (

                <span>

                  {achievement.icon}

                </span>

              )

            }

          </div>

          <span className="claim-label">

            ACHIEVEMENT UNLOCKED

          </span>

          <h2>

            {achievement.title}

          </h2>

        </div>

        {/* DESCRIPTION */}

        <p className="claim-description">

          {achievement.description}

        </p>

        {/* XP */}

        <div className="claim-reward">

          <FiGift />

          <span>

            +{achievement.xp} XP Earned

          </span>

        </div>

        {/* SUCCESS */}

        <div className="claim-success">

          <FiCheckCircle />

          <span>

            Successfully added to your profile

          </span>

        </div>

        {/* BUTTON */}

        <button

          className="claim-button"

          onClick={onClose}

        >

          Awesome!

        </button>

      </div>

    </div>

  );

};

export default ClaimModal;